import { useQuery } from "@tanstack/react-query";
import { ShipDataType } from "@/types/apiTypes";
import { fetchUserShipsApi } from "@/API/fetchUserShipsApi";
import { useLoadingContext } from "@/hooks/contextHooks/useLoadingContext";

export const useFetchUserShips = () => {
  const { startLoading, stopLoading } = useLoadingContext();

  const query = useQuery<ShipDataType[], Error>({
    queryKey: ["userShips"],
    queryFn: async () => {
      startLoading();

      try {
        return await fetchUserShipsApi();
      } finally {
        console.log("✅ Request completed.");
        stopLoading();
      }
    },
    retry: 1,
  });

  if (query.isFetching) {
    console.log("❌ Request overridden for user ships.");
  }

  return query;
};
